export const authTypes = {
  LOGIN                     : "@AUTH/LOGIN",
  LOGIN_SUCCESS             : "@AUTH/LOGIN_SUCCESS",
  LOGIN_FAILURE             : "@AUTH/LOGIN_FAILURE",
  LOGOUT                    : "@AUTH/LOGOUT",
  DID_TRY_AUTO_LOGIN        : "@AUTH/DID_TRY_AUTO_LOGIN",
  FORGOT_PASSWORD           : "@AUTH/FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS   : "@AUTH/FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE   : "@AUTH/FORGOT_PASSWORD_FAILURE",
  GET_USERS                 : "@AUTH/GET_USERS",
  GET_USERS_SUCCESS         : "@AUTH/GET_USERS_SUCCESS",
  GET_USERS_FAILURE         : "@AUTH/GET_USERS_FAILURE",
  GET_HELP_INFO             : "@AUTH/GET_HELP_INFO",
  GET_HELP_INFO_SUCCESS     : "@AUTH/GET_HELP_INFO_SUCCESS",
  GET_HELP_INFO_FAILURE     : "@AUTH/GET_HELP_INFO_FAILURE",
  GET_REFRESH_TOKEN         : "@AUTH/GET_REFRESH_TOKEN",
  GET_REFRESH_TOKEN_SUCCESS : "@AUTH/GET_REFRESH_TOKEN_SUCCESS",
  GET_REFRESH_TOKEN_FAILURE : "@AUTH/GET_REFRESH_TOKEN_FAILURE",
};

export interface LoginModelI {
  email: string;
  password: string;
}

export interface ForgotPasswordModelI {
  email: string | undefined;
}

export interface RefreshTokenModelI {
  refresh_token?: string;
}

export interface RefreshTokenSuccessI {
  refresh_token?: string;
}

export interface HelpInfoI {
  email?: string;
  message?: string;
  phone_number?: string;
}

export interface SupervisorUser {
  supervisor_id?: string;
  supervised_id?: string;
  set_rate?: boolean;
  set_truck_cost?: boolean;
  assign_customer?: boolean;
  set_outcome_status?: boolean;
  update_quote?: boolean;
  delete_quote?: boolean;
  supervised?: {
    user_id?: string;
    salesperson_id?: string;
    email?: string;
  };
}

export interface UserSessionI {
  access_token?: string;
  expires_in?: number;
  user_id?: string;
  avatar?: string;
  email?: string;
  name?: string;
  permissions?: Array<UserPermissionI>;
  phone_number?: string;
  role_id?: string;
  timezone?: UserTimezoneI;
  timezone_offset?: number;
  created_at?: Date;
  updated_at?: Date;
  auth0_id?: string;
  dispatch_division: DispatchDivisionI;
  supervisors?: Array<SupervisorUser>;
}

export type UserPermissionI = {
  name: string;
  permission_id: string;
  description: string;
}

export type DispatchDivisionI = {
  dispatch_division_id: number;
  country: string;
  city?: string;
}

export type UserTimezoneI = {
  abbreviation: string;
  offset: number;
  timezone_id: number;
  name: string;
  timezone: string;
}

export interface AuthStateI {
  loginLoading: boolean;
  loginError: string;
  user: UserSessionI;
  didTryAutoLogin: boolean;
  forgotPasswordLoading: boolean;
  forgotPasswordError: string;
  helpInfo?: HelpInfoI;
  helpInfoLoading: boolean;
  helpInfoError: string;
  maintenance: any;
  users: Array<any>;
}

export interface LoginI {
  type: typeof authTypes.LOGIN;
  payload: LoginModelI;
}
export interface LoginSuccessI {
  type: typeof authTypes.LOGIN_SUCCESS;
  payload: UserSessionI;
}

export interface LoginFailureI {
  type: typeof authTypes.LOGIN_FAILURE;
  payload: string;
}

export interface LogoutI {
  type: typeof authTypes.LOGOUT;
  payload?: string;
}

export interface didTryAutoLogin {
  type: typeof authTypes.DID_TRY_AUTO_LOGIN;
  payload?: string;
}

export interface ForgotPasswordI {
  type: typeof authTypes.FORGOT_PASSWORD;
  payload: ForgotPasswordModelI;
  onSuccess?: () => void;
}

export interface ForgotPasswordSuccessI {
  type: typeof authTypes.FORGOT_PASSWORD_SUCCESS;
  payload?: string;
}

export interface ForgotPasswordFailureI {
  type: typeof authTypes.FORGOT_PASSWORD_FAILURE;
  payload: string;
}

export interface GetHelpInfoI {
  type: typeof authTypes.GET_HELP_INFO;
  payload?: string;
}

export interface GetHelpInfoSuccessI {
  type: typeof authTypes.GET_HELP_INFO_SUCCESS;
  payload: HelpInfoI;
}

export interface GetHelpInfoFailureI {
  type: typeof authTypes.GET_HELP_INFO_FAILURE;
  payload?: string;
}
export interface RefreshTokenI {
  type: typeof authTypes.GET_REFRESH_TOKEN;
  payload: RefreshTokenModelI;
}

export interface GetRefreshTokenI {
  type: typeof authTypes.GET_REFRESH_TOKEN;
  payload: any;
  actionToDispatch: () => any;
}

export type getAuthTypes =
  | LoginI
  | LoginSuccessI
  | LoginFailureI
  | LogoutI
  | didTryAutoLogin
  | ForgotPasswordI
  | ForgotPasswordSuccessI
  | ForgotPasswordFailureI
  | GetHelpInfoI
  | GetHelpInfoSuccessI
  | GetHelpInfoFailureI
  | RefreshTokenI
